export const appPaths = {
  root: "/",
  home: "/home",

  generalError: "/error",
  notFound: "/not-found",
  unauthorized: "/unauthorized",

  // test
  authTest: "/auth-test",
  protected: "/protected",

  throwError: "/throw-error",

  auth: {
    root: "/_auth",
    signInCallback: "/_auth/login-callback",
    signOutCallback: "/_auth/logout-callback"
  },
  app: {
    root: "/:id",
    viewFeedback: "/:id/:code",
    addFeedback: "/:id/addfeedback",
    featureRequests: "/:id/featurerequests",
    bugReports: "/:id/bugreports",
    resourceRequests: "/:id/resourcerequests",
    viewFeatureRequest: "/:id/featurerequests/:code",
    viewBugReport: "/:id/bugreports/:code",
    viewResourceRequest: "/:id/resourcerequests/:code",
    admin: "/:id/admin"
  },
  topic: {
    root: "/topics",
    specificRoot: "/topics/:topicCode",
    feedback: "/topics/:topicCode/feedback",
    viewFeedback: "/topics/:topicCode/feedback/:code",
    featureRequests: "/topics/:topicCode/feedback/featurerequests",
    bugReports: "/topics/:topicCode/feedback/bugreports",
    viewFeatureRequest: "/topics/:topicCode/feedback/featurerequests/:code",
    viewBugReport: "/topics/:topicCode/feedback/bugreports/:code",
    viewResourceRequest: "/topics/:topicCode/feedback/resourcerequests/:code",
    addFeedback: "/topics/:topicCode/addfeedback",
    workflowTemplates: "/topics/workflowtemplates"
  },
  company: {
    topics: "/company/:shortname/topics",
    root: "/company/:shortname",
    featureRequests: "/company/:shortname/feedback/featurerequests",
    bugReports: "/company/:shortname/feedback/bugreports",
    resourceRequests: "/company/:shortname/feedback/resourceRequests",
    settings: "/company/:shortname/settings"
  },
  feedback: {
    root: "/feedback",
    submitFeedback: "/feedback/submit",
    viewFeedback: "/feedback/:code",
    editFeedback: "/feedback/:code/edit",
    deleteFeedback: "/feedback/:code/delete"
  },
  user: {
    root: "/user/:username",
    featureRequests: "/user/:username/feedback/featurerequests",
    bugReports: "/user/:username/feedback/bugreports",
    resourceRequests: "/user/:username/feedback/resourceRequests",
    assigned: "/user/:username/assigned",
    settings: "/user/:username/settings"
  },
  search: {
    root: "/search",
    results: "/search/results",
    advanced: "/search/advanced/results"
  },
  workflows: {
    root: "/workflows",
    edit: "/workflows/:code"
  },
  tags: {
    root: "/tags",
    details: "/tags/:tagId"
  },
  overview: {
    root: "/overview"
  }
};
